import { CollectionId, ProductId, TokenId } from "@/src/types";
import DetailsTab from "./components/DetailsTab";
import StoryTab from "./components/StoryTab";
import UtilityTab from "./components/UtilityTab";

export enum TABS {
  STORY = "story",
  DETAILS = "details",
  UTILITY = "utility",
  ACTIVITY = "activity",
}

const tabMap = {
  [TABS.STORY]: StoryTab,
  [TABS.UTILITY]: UtilityTab,
  [TABS.DETAILS]: DetailsTab,
  [TABS.ACTIVITY]: () => <div className="dark:text-white">Activity tab</div>,
};

export const renderTab = (
  tab: string,
  productName: ProductId,
  collectionName: CollectionId,
  tokenId: TokenId,
) => {
  const TabComponent = tabMap[tab as TABS] ?? StoryTab;
  return (
    <TabComponent
      productName={productName}
      collectionName={collectionName}
      tokenId={tokenId}
    />
  );
};
